export const jiliGames = {
  JackpotFishing : {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "JackpotFishing",
      name: "Jackpot Fishing",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/JackpotFishing.jpg",
      redirectUrl: "/casino/aggapjiligaming-jackpot-fishing",
    },
   MegaFishing : {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "MegaFishing",
      name: "Mega Fishing",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/MegaFishing.jpg",
      redirectUrl: "/casino/aggapjiligaming-mega-fishing",
    },
   FortuneGems2 : {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "FortuneGems2",
      name: "Fortune Gems 2",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortunegems2.jpg",
      redirectUrl: "/casino/aggapjiligaming-fortune-gems-2",
    },
   FortuneGems3 : {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "FortuneGems3",
      name: "Fortune Gems 3",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortunegems3.jpg",
      redirectUrl: "/casino/aggapjiligaming-fortune-gems-3",
    },
    Poolrummy : {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pool Rummy",
      name: "Pool Rummy",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/PoolRummy.webp",
      redirectUrl: "/casino/aggapjiligaming-pool-rummy",
    },
      rummy7364: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rummy",
      name: "Rummy",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/rummy-u7364.webp",
      redirectUrl: "/casino/aggapjiligaming-rummy-u7364",
    },
      rummy: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Rummy",
      name: "Rummy",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/rummy.webp",
      redirectUrl: "/casino/aggapjiligaming-rummy",
    },
     Threecardrummy: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "three card rummy",
      name: "Three card ummy",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/threecardrummy.webp",
      redirectUrl: "/casino/aggapbetsoft-three-card-rummy",
    },
    PirateQueen: {
      code: "98567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Pirate Queen",
      name: "Pirate Queen",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Piratequeen.jpg",
      redirectUrl: "/casino/aggapjiligaming-pirate-queen",
    },
    WildRacer: {
      code: "56768",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Racer",
      name: "Wild Racer",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Wildracer.jpg",
      redirectUrl: "/casino/aggapjiligaming-wild-racer",
    },
    NekoFortune: {
      code: "98790",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Neko Fortune",
      name: "Neko Fortune",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/nekofortune.jpg",
      redirectUrl: "/casino/aggapjiligaming-neko-fortune",
    },
    Samba: {
      code: "98789",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Samba",
      name: "Samba",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/samba.jpg",
      redirectUrl: "/casino/aggapjiligaming-samba",
    },
    WorldCup: {
      code: "56968",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "World Cup",
      name: "World Cup",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/worldcup.jpg",
      redirectUrl: "/casino/aggapjiligaming-world-cup",
    },
    BonusHunter: {
      code: "67660",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bonus Hunter",
      name: "Bonus Hunter",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bonushunter.jpg",
      redirectUrl: "/casino/aggapjiligaming-bonus-hunter",
    },
    JILICAISHEN: {
      code: "67580",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "JILI CAISHEN",
      name: "JILI CAISHEN",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jilicaishen.jpg",
      redirectUrl: "/casino/aggapjiligaming-jili-caishen",
    },
    MayanEmpire: {
      code: "67600",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Mayan Empire",
      name: "Mayan Empire",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/mayanempire.jpg",
      redirectUrl: "/casino/aggapjiligaming-mayan-empire",
    },
    BoneFortune: {
      code: "87564",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Bone Fortune",
      name: "Bone Fortune",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bonefortune.jpg",
      redirectUrl: "/casino/aggapjiligaming-bone-fortune",
    },
    GoldRush: {
      code: "67620",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Gold Rush",
      name: "Gold Rush",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/goldrush.jpg",
      redirectUrl: "/casino/aggapjiligaming-gold-rush",
    },
    HappyTaxi: {
      code: "67567",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Happy Taxi",
      name: "Happy Taxi",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/happytaxi.jpg",
      redirectUrl: "/casino/aggapjiligaming-happy-taxi",
    },
    ThorX: {
      code: "67570",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Thor X",
      name: "Thor X",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/ThorX.jpg",
      redirectUrl: "/casino/aggapjiligaming-thor-x",
    },
    BookofGold: {
      code: "56767",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Book of Gold",
      name: "Book of Gold",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/bookofgold.jpg",
      redirectUrl: "/casino/aggapjiligaming-book-of-gold",
    },
    Medusa: {
      code: "98788",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Medusa",
      name: "Medusa",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/medusa.jpg",
      redirectUrl: "/casino/aggapjiligaming-medusa",
    },
    GoGoalBingo: {
      code: "98791",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Go Goal Bingo",
      name: "Go Goal Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/gogoalbingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-go-goal-bingo",
    },
    ColorGame: {
      code: "67630",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Color Game",
      name: "Color Game",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/colorgame.jpg",
      redirectUrl: "/casino/aggapjiligaming-color-game",
    },
    JackpotBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jackpot Bingo",
      name: "Jackpot Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jackpotbingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-jackpot-bingo",
    },
    LuckyBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Bingo",
      name: "Lucky Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/luckybingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-lucky-bingo",
    },
    WinDrop: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Win Drop",
      name: "Win Drop",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/windrop.jpg",
      redirectUrl: "/casino/aggapjiligaming-win-drop",
    },
    FortuneBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Bingo",
      name: "Fortune Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortunebingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-fortune-bingo",
    },
    Baccarat: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Baccarat",
      name: "Baccarat",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/baccarat.jpg",
      redirectUrl: "/casino/aggapjiligaming-baccarat",
    },
    iRichBingo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "iRich Bingo",
      name: "iRich Bingo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/iRichBingo.jpg",
      redirectUrl: "/casino/aggapjiligaming-irich-bingo",
    },
    DragonTiger: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Dragon & Tiger",
      name: "Dragon & Tiger",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Dragon_tiger.jpg",
      redirectUrl: "/casino/aggapjiligaming-dragon-and-tiger",
    },
    BigSmall: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Big Small",
      name: "Big Small",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Bigsmall.jpg",
      redirectUrl: "/casino/aggapjiligaming-big-small",
    },
    GoldenJoker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Golden Joker",
      name: "Golden Joker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/goldenjoker.jpg",
      redirectUrl: "/casino/aggapjiligaming-golden-joker",
    },
    MasterTiger: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Master Tiger",
      name: "Master Tiger",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/mastertiger.jpg",
      redirectUrl: "/casino/aggapjiligaming-master-tiger",
    },
    WildAce: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Wild Ace",
      name: "Wild Ace",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Wildace.jpg",
      redirectUrl: "/casino/aggapjiligaming-wild-ace",
    },
    Crazy777: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy 777",
      name: "Crazy 777",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/Crazy777.jpg",
      redirectUrl: "/casino/aggapjiligaming-crazy777",
    },
    DominoGo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Domino Go",
      name: "Domino Go",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/dominogo.jpg",
      redirectUrl: "/casino/aggapjiligaming-domino-go",
    },
    UltimateTexasHoldem: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Ultimate Texas Hold'em",
      name: "Ultimate Texas Hold'em",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/ultimatetexasholdem.jpg",
      redirectUrl: "/casino/aggapjiligaming-ultimate-texas-holdem",
    },
    KenoBonusNumber: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Keno Bonus Number",
      name: "Keno Bonus Number",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/kenobonusnumber.jpg",
      redirectUrl: "/casino/aggapjiligaming-keno-bonus-number",
    },
    CrashCricket: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash Cricket",
      name: "Crash Cricket",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/crashcricket.jpg",
      redirectUrl: "/casino/aggapjiligaming-crash-cricket",
    },
    CrashGoal: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crash Goal",
      name: "Crash Goal",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/crashgoal.jpg",
      redirectUrl: "/casino/aggapjiligaming-crash-goal",
    },
    FortuneRoulette: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune Roulette",
      name: "Fortune Roulette",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortuneroulette.jpg",
      redirectUrl: "/casino/aggapjiligaming-fortune-roulette",
    },
    CricketRoulette: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Cricket Roulette",
      name: "Cricket Roulette",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/cricketroulette.jpg",
      redirectUrl: "/casino/aggapjiligaming-cricket-roulette",
    },
    SuperESabong: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super E-Sabong",
      name: "Super E-Sabong",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/super-e-sabong.jpg",
      redirectUrl: "/casino/aggapjiligaming-super-e-sabong",
    },
    ThaiHilo: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Thai Hilo",
      name: "Thai Hilo",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/thaihilo.jpg",
      redirectUrl: "/casino/aggapjiligaming-thai-hilo",
    },
    BoxingExtravaganza: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Boxing Extravaganza",
      name: "Boxing Extravaganza",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/boxingextravaganza.jpg",
      redirectUrl: "/casino/aggapjiligaming-boxing-extravaganza",
    },
    JhandiMunda: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Jhandi Munda",
      name: "Jhandi Munda",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/jhandimunda.jpg",
      redirectUrl: "/casino/aggapjiligaming-jhandi-munda",
    },
    SuperAceScratch: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Ace Scratch",
      name: "Super Ace Scratch",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/superacescratch.jpg",
      redirectUrl: "/casino/aggapjiligaming-super-ace-scratch",
    },
    FishPrawnCrab: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fish Prawn Crab",
      name: "Fish Prawn Crab",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fishprawncrab.jpg",
      redirectUrl: "/casino/aggapjiligaming-fish-prawn-crab",
    },
    LuckyJaguar: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Lucky Jaguar",
      name: "Lucky Jaguar",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/luckyjaguar.jpg",
      redirectUrl: "/casino/aggapjiligaming-lucky-jaguar",
    },
    Shōgun: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Shōgun",
      name: "Shōgun",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/shogun.jpg",
      redirectUrl: "/casino/aggapjiligaming-shogun",
    },
    MoneyPot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Money Pot",
      name: "Money Pot",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/moneypot.jpg",
      redirectUrl: "/casino/aggapjiligaming-money-pot",
    },
    NightfallHunting: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Nightfall Hunting",
      name: "Nightfall Hunting",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/nightfallhunting.jpg",
      redirectUrl: "/casino/aggapjiligaming-nightfall-hunting",
    },
    PotDragons3: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Pot Dragons",
      name: "3 Pot Dragons",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/3potdragon.jpg",
      redirectUrl: "/casino/aggapjiligaming-3-pot-dragons",
    },
    Poseidon: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Poseidon",
      name: "Poseidon",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/poseidon.jpg",
      redirectUrl: "/casino/aggapjiligaming-poseidon",
    },
    LuckyPiggy3: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "3 Lucky Piggy",
      name: "3 Lucky Piggy",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/3luckypiggy.jpg",
      redirectUrl: "/casino/aggapjiligaming-3-lucky-piggy",
    },
    EgyptsGlow: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Egypt's Glow",
      name: "Egypt's Glow",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/egyptsglow.jpg",
      redirectUrl: "/casino/aggapjiligaming-egypts-glow",
    },
    PartyStar: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Party Star",
      name: "Party Star",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/partystar.jpg",
      redirectUrl: "/casino/aggapjiligaming-party-star",
    },
    MoneyComingExpandBets: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Money Coming Expand Bets",
      name: "Money Coming Expand Bets",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/moneycomingexpandedbets.jpg",
      redirectUrl: "/casino/aggapjiligaming-money-coming-expand-bets",
    },
    SuperAceeluxe: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Super Ace Deluxe",
      name: "Super Ace Deluxe",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/superacedeluxe.jpg",
      redirectUrl: "/casino/aggapjiligaming-super-ace-deluxe",
    },
    LegacyofEgypt: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Legacy of Egypt",
      name: "Legacy of Egypt",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/legacyofegypt.jpg",
      redirectUrl: "/casino/aggapjiligaming-legacy-of-egypt",
    },
    ThePigHouse: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "The Pig House",
      name: "The Pig House",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/thepighouse.jpg",
      redirectUrl: "/casino/aggapjiligaming-the-pig-house",
    },
    CrazyHunter2: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Crazy Hunter 2",
      name: "Crazy Hunter 2",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/crazyhunter2.jpg",
      redirectUrl: "/casino/aggapjiligaming-crazy-hunter-2",
    },
    FortuneKingJackpot: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Fortune King Jackpot",
      name: "Fortune King Jackpot",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/fortunekingjackpot.jpg",
      redirectUrl: "/casino/aggapjiligaming-fortune-king-jackpot",
    },
    VideoPoker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Video Poker",
      name: "Video Poker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/videopoker.jpg",
      redirectUrl: "/casino/aggapjiligaming-video-poker",
    },
    CaribbeanStudPoker: {
      code: "98566",
      casino: "aura",
      provider: "ALT_GAMING_GAP",
      homeUrl: "http://localhost:3000/Casino",
      alt: "Caribbean Stud Poker",
      name: "Caribbean Stud Poker",
      providerName: "Jili Gaming",
      imgUrl: "./images/alt-gaming/jili-game/caribbeanstudpoker.jpg",
      redirectUrl: "/casino/aggapjiligaming-caribbean-stud-poker",
    },
  }